var map = {
	"./Switch.svg": 297,
	"./alert-icons/alert-icon-1.svg": 630,
	"./alert-icons/alert-icon-10.svg": 172,
	"./alert-icons/alert-icon-11.svg": 631,
	"./alert-icons/alert-icon-12.svg": 173,
	"./alert-icons/alert-icon-2.svg": 632,
	"./alert-icons/alert-icon-3.svg": 633,
	"./alert-icons/alert-icon-4.svg": 634,
	"./alert-icons/alert-icon-5.svg": 635,
	"./alert-icons/alert-icon-6.svg": 636,
	"./alert-icons/alert-icon-7.svg": 637,
	"./alert-icons/alert-icon-8.svg": 638,
	"./alert-icons/alert-icon-9.svg": 639,
	"./autofact-logo-new.svg": 88,
	"./autofact-logo-white.svg": 640,
	"./autofact-logo.svg": 641,
	"./cameraRecord.svg": 298,
	"./card-identity-type-new.png": 174,
	"./card-identity-type-old.png": 175,
	"./check-purple.svg": 642,
	"./check-v2.svg": 643,
	"./check.svg": 62,
	"./checklist.svg": 70,
	"./ci-antigua-ejemplo-back.png": 299,
	"./ci-antigua-ejemplo-front.png": 300,
	"./ci-back-ejemplo.jpg": 301,
	"./ci-back-new.svg": 644,
	"./ci-back.svg": 645,
	"./ci-ejemplo.jpg": 302,
	"./ci-front.svg": 646,
	"./claveunica.svg": 176,
	"./clock-icon.svg": 177,
	"./close.svg": 647,
	"./close_new.svg": 178,
	"./document-new.svg": 648,
	"./download-new.svg": 649,
	"./face-verification.svg": 179,
	"./face.svg": 650,
	"./fingerprint.svg": 180,
	"./front-card.svg": 181,
	"./ic-alert-modal.svg": 89,
	"./ic-back.svg": 651,
	"./ic-background.png": 652,
	"./ic-background.svg": 653,
	"./ic-camera-modal.svg": 182,
	"./ic-error-modal.svg": 90,
	"./ic-front.svg": 654,
	"./ic-instruction-01.svg": 655,
	"./ic-instruction-02.svg": 656,
	"./ic-instruction-03.svg": 657,
	"./ic-instruction-04.svg": 658,
	"./ic-instruction-05.png": 659,
	"./ic-instruction-05.svg": 660,
	"./ic-instruction-06.svg": 661,
	"./ic-instruction-07.svg": 662,
	"./ic-instruction-08.svg": 663,
	"./ic-instruction-09.svg": 664,
	"./ic-instruction-10.svg": 665,
	"./ic-instruction-11.svg": 666,
	"./ic-instruction-12.svg": 667,
	"./ic-instruction-13.svg": 668,
	"./ic-instruction-14.svg": 669,
	"./ic-instruction-15.svg": 670,
	"./ic-lightbulb.svg": 671,
	"./ic-unique-key-description.svg": 183,
	"./information-cirlce-gray.svg": 113,
	"./loading.gif": 672,
	"./logo-ecert-azul.svg": 673,
	"./logo-ecert-color.svg": 674,
	"./logo.svg": 675,
	"./logo_ecert.svg": 676,
	"./mandate.svg": 677,
	"./new-ci-back-ejemplo-2.jpeg": 303,
	"./new-ci-back-ejemplo.jpg": 678,
	"./new-ci-front-ejemplo.jpg": 304,
	"./notary-declaration.svg": 184,
	"./ok-circle.svg": 185,
	"./phosphoricons-clock-clockwise.svg": 186,
	"./red-cross.svg": 679,
	"./redirect.svg": 680,
	"./signature-new.svg": 681,
	"./signature.svg": 187,
	"./times-circle-solid.svg": 91,
	"./turn-phone.svg": 682,
	"./turncamera.svg": 165,
	"./unique_key_description.svg": 60,
	"./warning-circle.svg": 188
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 38;